// Aug-2026 (User-Wunsch): Anschrift-Vollständigkeitsprüfung vor dem
// Festschreiben von Rechnungen (fehlende Hausnummer, Name, Straße, PLZ, Ort).
export function addressIssues(c) {
    if (!c || !c.id) return [];
    const issues = [];
    const isBiz = c.type === "business" && (c.company_name || "").trim();
    if (!isBiz) {
        if (!(c.first_name || "").trim()) issues.push("Vorname");
        if (!(c.last_name || "").trim()) issues.push("Nachname");
    }
    const street = (c.street || "").trim();
    if (!street) issues.push("Straße");
    else if (!/\d/.test(street + String(c.house_number || ""))) issues.push("Hausnummer");
    if (!String(c.zip || "").trim()) issues.push("PLZ");
    if (!(c.city || "").trim()) issues.push("Ort");
    return issues;
}
